// Copyright 2025, University of Maryland, All Rights Reserved
import { AlertTriangle } from 'lucide-react';

interface WorkspaceRequiredGuardProps {
  selectedOrganizationId?: string | null;
  selectedWorkspaceId?: string | null;
  children: React.ReactNode;
  title?: string;
  message?: string;
}

/**
 * Guard component that shows an error message when workspace context is missing
 * and renders children when workspace is selected
 */
export function WorkspaceRequiredGuard({
  selectedOrganizationId,
  selectedWorkspaceId,
  children,
  title = 'Workspace Required',
  message = 'Please select an organization and workspace to continue.',
}: WorkspaceRequiredGuardProps) {
  if (!selectedOrganizationId || !selectedWorkspaceId) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <AlertTriangle className="w-16 h-16 text-amber-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-700 mb-2">{title}</h3>
          <p className="text-gray-500">{message}</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
